import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, useLocation, useHistory } from 'react-router-dom';

/**
 * Actions
 */
import { logout } from 'modules/auth/actions/authentication.action';

const PrivateRoute = ({
    component: Component,
    authUser,
    logout,
    ...rest
}) => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (authUser && authUser.isOperator) {
            logout();
            history.replace('/auth/login');
        }
    }, [authUser]);

    return (
        <Route
            {...rest}
            render={props => (
                authUser
                    ? (
                        <Component {...props} />
                    )
                    : (
                        <Redirect
                            to={{ pathname: '/auth/login', state: { from: location } }}
                        />
                    )
            )}
        />
    );
}

const mapStateToProps = state => ({
    authUser: state.authentication.authUser,
});

const mapDispatchToProps = {
    logout,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PrivateRoute);
